import React, {useState} from 'react';
import {Space, Spin} from 'antd';

import {Button, Modal, Typography} from '@components/common';
import SharingService from '@utils/apis/SharingService';
import {trackError} from '@utils/createSentry';

enum ModalState {
  Confirm,
  Loading,
  Success,
  Error,
}

const RevokeObjectModal = ({
  isVisible,
  closeModal,
  object,
  organization,
  onRevokeSuccess
}: any) => {
  const [modalState, setModalState] = useState(ModalState.Confirm);
  const [errorMessage, setErrorMessage] = useState('');

  const revokeObject = async () => {
    try {
      setModalState(ModalState.Loading);
      await SharingService.revokeObjectFromActor(object, organization);
      setModalState(ModalState.Success);
      onRevokeSuccess();
    } catch (e) {
      setModalState(ModalState.Error);
      setErrorMessage(e.message);
      trackError(e);
    }
  };

  const ModalMessage = () => {
    switch (modalState) {
    case ModalState.Confirm:
      return (
        <Typography variant="primary" as="p">
            You are about to revoke the rose {object.type} <b>{object.code}</b>{' '}
            from <b>{organization.code}</b>.
        </Typography>
      );
    case ModalState.Loading:
      return (
        <Space direction="vertical" align="center">
          <Spin size="large" />
        </Space>
      );
    case ModalState.Success:
      return (
        <Typography variant="primary" as="p">
          {'Successfully revoked dataset '}
          <b>{object.code}</b>
        </Typography>
      );
    case ModalState.Error:
      return <Typography variant="primary" as="p">{errorMessage}</Typography>;
    default:
      return null;
    }
  };

  const modalFooter = () => {
    switch (modalState) {
    case ModalState.Confirm:
      return [
        <Button id="cancel" key="cancel" onClick={closeModal}>
            Cancel
        </Button>,
        <Button id="revoke" key="revoke" onClick={revokeObject}>
            Revoke
        </Button>
      ];
    case ModalState.Loading:
      return null;
    case ModalState.Success || ModalState.Error:
      return [
        <Button key="ok" onClick={closeModal}>
            OK
        </Button>
      ];
    default:
      return null;
    }
  };

  const getModalTitle = () => {
    switch (modalState) {
    case ModalState.Confirm:
      return 'Revoke';
    case ModalState.Loading:
      return 'Loading...';
    case ModalState.Success:
      return 'Success';
    case ModalState.Error:
      return 'Error occured';
    default:
      return '';
    }
  };

  return (
    <Modal
      title={getModalTitle()}
      visible={isVisible}
      footer={modalFooter()}
      onCancel={closeModal}
    >
      <ModalMessage />
    </Modal>
  );
};

export default RevokeObjectModal;
